// Maps importedName -> preview data URL for in-flight uploads.
// For canvas import videos: importedName is the UUID S3 key stem (unique). For desktop uploads, importedName is the filename stem.
const previewByImportedName = new Map<string, string>();

export const registerUploadPreview = (importedName: string, dataUrl: string) => {
  previewByImportedName.set(importedName, dataUrl);
};

export const getUploadPreview = (importedName: string | undefined): string | undefined => {
  if (!importedName) {
    return undefined;
  }

  return previewByImportedName.get(importedName);
};

export const releaseUploadPreview = (importedName: string) => {
  const url = previewByImportedName.get(importedName);

  if (url?.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }

  previewByImportedName.delete(importedName);
};
